import { Stack } from "@mui/material";
import StatCard from "./StatCard";
import helpers from "../../../hooks/HelperFunctions";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CampaignIcon from '@mui/icons-material/Campaign';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PaymentsIcon from '@mui/icons-material/Payments';

function CreatorStats({ totalPaid, totalCampaigns, maximumPayment, recentPayment }) {
    return (
        <Stack direction="row" sx={{ mt: 2 }} columnGap={2} flexWrap="wrap" rowGap={2}>
            <StatCard
                heading="Total Paid"
                value={helpers.formatNumber(totalPaid, true)}
                icon={<CurrencyRupeeIcon sx={{ fontSize: 18 }} />}
                accentColor="#FF5200"
            />
            <StatCard
                heading="Total Campaigns"
                value={`${totalCampaigns}`}
                icon={<CampaignIcon sx={{ fontSize: 18 }} />}
                accentColor="#6366F1"
            />
            <StatCard
                heading="Highest Payment"
                value={helpers.formatNumber(maximumPayment, true)}
                icon={<TrendingUpIcon sx={{ fontSize: 18 }} />}
                accentColor="#10B981"
            />
            <StatCard
                heading="Last Paid Amount"
                value={helpers.formatNumber(recentPayment, true)}
                icon={<PaymentsIcon sx={{ fontSize: 18 }} />}
                accentColor="#F59E0B"
            />
        </Stack>
    );
}

export default CreatorStats;
